jQuery(function( $ ){

  
    // init controller
  var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

  // build scenes
  new ScrollMagic.Scene({triggerElement: ".parallax-window-home"})
  .setTween(".parallax-window-home > .parallax-body-home", {y: "80%", ease: Linear.easeNone})
  .addTo(controller);
  
  
  
$('#home_slider').slick({
  dots: false,
  nav:true,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
  nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
   responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: false,
  nav:false
      }
    }
    ]
});
  
  
  $('#home_slider2').slick({
  dots: false,
  nav:true,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
  nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
   responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: false,
  nav:false
      }
    }
    ]
});
  
  
  $('.media-slide').slick({
  dots: false,
  nav:true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
  nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>'
});
  
  $('.related-prod').slick({
  dots: false,
  nav:true,
  infinite: true,
  speed: 300,
    autoplay: true,
  slidesToShow: 3,
  prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
  nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


  $( ".template-collection.products header h1" ).text( "All Products" );
   $( ".template-collection .breadcrumb  .btitle" ).text( "All Products" );
  $( ".template-blog.news .section-header h1" ).text( "Blog" );
  
  $('.filters-toolbar__product-count').each(function() {
    var text = $(this).text();
    $(this).text(text.replace('products', 'item')); 
});
  
  
   $( ".paginate .prev a " ).text( "PREV" );
  $( ".paginate .next a " ).text( "NEXT" );
});
